export default "__VITE_ASSET__DJENyfh___"